// Runtime-editable brand palette. Colors map to CSS variables (--ct-<key>)
// consumed by Tailwind (rgb(var(--ct-x) / <alpha-value>)).

export const THEME_COLORS = [
  { key: "blue", label: "Primary Blue", d: "#0047AB" },
  { key: "marigold", label: "Gold Accent", d: "#E9C46A" },
  { key: "navy", label: "Deep Navy", d: "#0A1F5C" },
  { key: "navydeep", label: "Darkest Navy", d: "#071847" },
  { key: "bluedeep", label: "Blue (deep)", d: "#00337A" },
  { key: "terracotta", label: "Terracotta", d: "#E76F51" },
  { key: "turquoise", label: "Turquoise", d: "#00B4D8" },
  { key: "chili", label: "Chili Red", d: "#D1462F" },
  { key: "purple", label: "Purple", d: "#6B3FA0" },
  { key: "magenta", label: "Magenta", d: "#D62F72" },
  { key: "agave", label: "Agave Green", d: "#5B8A5B" },
  { key: "cream", label: "Cream Background", d: "#FDFBF7" },
  { key: "surface", label: "Card Surface", d: "#FFFFFF" },
  { key: "alt", label: "Alt Background", d: "#FAF4E9" },
  { key: "ink", label: "Ink / Body Text", d: "#17233B" },
  { key: "line", label: "Lines / Borders", d: "#ECDFC9" },
];

export const DEFAULT_THEME = THEME_COLORS.reduce((acc, c) => {
  acc[c.key] = c.d;
  return acc;
}, {});

// "Site chrome" colors stored as raw hex (no alpha modifiers needed).
export const CHROME_COLORS = [
  { key: "scrollbarTrack", label: "Scrollbar Track", d: "#FAF4E9" },
  { key: "scrollbarThumb", label: "Scrollbar Thumb", d: "#0047AB" },
  { key: "scrollbarThumbHover", label: "Scrollbar Thumb (hover)", d: "#E76F51" },
  { key: "selectionBg", label: "Text Selection", d: "#E76F51" },
  { key: "selectionText", label: "Selected Text", d: "#FFFFFF" },
];

CHROME_COLORS.forEach((c) => { DEFAULT_THEME[c.key] = c.d; });

const CHROME_VAR = {
  scrollbarTrack: "--ct-scrollbar-track",
  scrollbarThumb: "--ct-scrollbar-thumb",
  scrollbarThumbHover: "--ct-scrollbar-thumb-hover",
  selectionBg: "--ct-selection-bg",
  selectionText: "--ct-selection-text",
};

export const hexToChannels = (hex) => {
  if (!hex || typeof hex !== "string") return null;
  let h = hex.replace("#", "").trim();
  if (h.length === 3) h = h.split("").map((x) => x + x).join("");
  if (h.length !== 6) return null;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  if ([r, g, b].some(Number.isNaN)) return null;
  return `${r} ${g} ${b}`;
};

export const applyTheme = (theme = {}) => {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  THEME_COLORS.forEach(({ key, d }) => {
    const ch = hexToChannels(theme[key] || d);
    if (ch) root.style.setProperty(`--ct-${key}`, ch);
  });
  CHROME_COLORS.forEach(({ key, d }) => {
    root.style.setProperty(CHROME_VAR[key], theme[key] || d);
  });
};
